import { IStore } from '@/modules/mixing/components/mixing-by-params-modal/hooks';
import { createEvent } from '@/shared/lib/state-engine';
import { createStore } from 'effector';
import { SEARCH_ACTIVE_TAB, SEARCH_BY_OFFERS_LOCAL_STORAGE_KEY } from '../constants';
import { isEqual } from 'lodash-es';

const searchFiltersState = {
  buyers: [
    { value: 'все', label: '', enabled: true, id: 0 },
    { value: 'активные', label: '', enabled: false, id: 1 },
  ],
  sort: [
    { id: 0, value: 'твердая', label: '', enabled: false, display: true },
    { id: 1, value: 'мягкая краснозерная', label: '', enabled: false, display: true },
    { id: 2, value: 'мягкая белозерная', label: '', enabled: false, display: true },
  ],
  type: [
    { id: 0, value: 'яровая', label: '', enabled: false, display: true },
    { id: 1, value: 'озимая', label: '', enabled: false, display: true },
  ],
  wheatClass: [
    { label: '1-й класс', checked: false, id: '1' },
    { label: '2-й класс', checked: false, id: '2' },
    { label: '3-й класс', checked: false, id: '3' },
    { label: '4-й класс', checked: false, id: '4' },
    { label: '5-й класс', checked: false, id: '5' },
  ],
};

const cachedSearchState = localStorage.getItem(SEARCH_BY_OFFERS_LOCAL_STORAGE_KEY);
const parsed = cachedSearchState ? JSON.parse(cachedSearchState) : null;

export const $selectedWarehousesForSearch = createStore<IStore[]>(parsed || []);
export const setSelectedWarehousesForSearch = createEvent<IStore[]>();
$selectedWarehousesForSearch.on(setSelectedWarehousesForSearch, (_d, p) => {
  if (isEqual(p, [])) return;
  localStorage.setItem(SEARCH_BY_OFFERS_LOCAL_STORAGE_KEY, JSON.stringify(p));
  return p;
});
export const $searchFiltersState = createStore(searchFiltersState);
export const setSearchFilters = createEvent<ISearchFilters>();
// @ts-ignore
$searchFiltersState.on(setSearchFilters, (_s, p) => p);

type FilterOption = {
  value: string;
  label: string;
  enabled: boolean;
  id: number;
  display: boolean; 
};

export interface ISearchFilters {
  buyers: Omit<FilterOption, 'display'>[];
  sort: FilterOption[];
  type: FilterOption[];
  wheatClass: { label: string, checked: boolean, id: string }[];
}

const activeTabFromLocalStorage: any = localStorage.getItem(SEARCH_ACTIVE_TAB);

export const setActiveSearchTab = createEvent<2 | 1 | 0>();
export const $activeSearchTab = createStore<2 | 1 | 0>(Number(activeTabFromLocalStorage) as 2 | 1 | 0 || 0).on(setActiveSearchTab, (_S, p) => {
  localStorage.setItem(SEARCH_ACTIVE_TAB, String(p));
  return p;
});
